import { HttpClient } from '@angular/common/http';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { FileDto } from '@shared/service-proxies/service-proxies';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VfBlobService {

  constructor(private http: HttpClient) { }

  download(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob'
    });
  }
}
